import React from 'react'
import { useTranslation } from 'react-i18next'
import { IssueEntity } from 'types/IssueEntity'
import { FactsTableRow } from '../../components/FactsTable'
import { getSubPriceLabel } from '../../../utils/issues/getSubPriceLabel'

export function SubPriceRow({ issue }: { issue: IssueEntity }) {
    const { t, i18n } = useTranslation()
    const locale = i18n.language

    const subPriceLabel = getSubPriceLabel({ issue, locale })

    return <FactsTableRow label={t('pages.issues.terms.subPrice')}>{subPriceLabel}</FactsTableRow>
}
